import { CreateFileV2 } from '../../File';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { PersonalPropertyItemFormValues } from '..';
import { usePersonalPropertyItemFormContext } from '../../PersonalPropertyItem/context';

interface PersonalPropertyItemCreateFileInputProps {
  className?: string;
}

export const PersonalPropertyItemCreateFileInput = ({ className }: PersonalPropertyItemCreateFileInputProps) => {
  const { t: tForm } = useTranslation('form');
  const { setValue, watch } = useFormContext<PersonalPropertyItemFormValues>();
  const { householdID } = usePersonalPropertyItemFormContext();

  const [pendingFiles] = watch(['pendingFiles']);

  return (
    <CreateFileV2
      className={className}
      tenantID={householdID}
      label={tForm('general-add-related-documents')}
      onFileCreation={(file) => {
        setValue('pendingFiles', (pendingFiles || []).concat(file));
      }}
    />
  );
};
